"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.assign");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es6.function.name");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _hexColorToRgb = _interopRequireDefault(require("../hex-color-to-rgb"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartWordCloudOptions = _interopRequireDefault(require("./mw-chart-word-cloud-options"));

var _mwChartWordCloudClickOptions = _interopRequireDefault(require("./mw-chart-word-cloud-click-options"));

var _mwChartWordCloudTooltipOptions = _interopRequireDefault(require("./mw-chart-word-cloud-tooltip-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _wordcloud = _interopRequireDefault(require("highcharts/modules/wordcloud"));

var _styles = require("../styles");

var OPACITY = 0.6;
var HIGHLIGHT_OPACITY = 0.8;

function applyOpacityToChart(data) {
  return data.every(function (word) {
    return word.name.length <= 2;
  });
}

function wordCloudData(series, maxNameLength) {
  var data = [];

  if (typeof series.data !== 'undefined') {
    data = series.data.map(function (wordSeries) {
      var truncatedName = wordSeries.key;

      if (truncatedName.length > maxNameLength) {
        var truncatedNameBase = truncatedName.slice(0, maxNameLength - 1).trim();
        truncatedName = "".concat(truncatedNameBase, "\u2026");
      }

      return {
        name: truncatedName,
        weight: wordSeries.value
      };
    });
  }

  return {
    name: series.name,
    type: 'wordcloud',
    data: data
  };
}
/**
 * A class for rendering a word cloud chart
 */


var MwChartWordCloud =
/*#__PURE__*/
function () {
  /**
   * Create a new Word Cloud Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function MwChartWordCloud(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartWordCloud);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartWordCloud, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      if (!chartData) {
        this.__chartData = {};
      } else {
        this.__chartData = (0, _coerce.default)(chartData, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
      }
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartWordCloudChartOptions} chartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(chartOptions) {
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartWordCloudOptions.default, "chartOptions must be a valid MwChartWordCloudChartOptions object. Provided value: ".concat(JSON.stringify(chartOptions)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      try {
        this.error = false;

        if (!this.__renderTarget) {
          throw new Error('renderTarget not set. Unable to render visualization');
        }

        (0, _wordcloud.default)(_highcharts.default);
        var highchartsData = [wordCloudData(this.__chartData, this.__chartOptions.maxPhraseLength)];
        var checkToApplyOpacity = applyOpacityToChart(highchartsData[0].data);
        var safeHighchartOptions = this.__chartOptions;
        var rgbColor = (0, _hexColorToRgb.default)(safeHighchartOptions.seriesColor);
        var safeHighlightColor = "rgba(".concat(rgbColor.red, ",").concat(rgbColor.green, ",").concat(rgbColor.blue, ", ").concat(HIGHLIGHT_OPACITY, ")");
        var seriesColor = [safeHighchartOptions.seriesColor];

        if (!checkToApplyOpacity) {
          seriesColor.push("rgba(".concat(rgbColor.red, ",").concat(rgbColor.green, ",").concat(rgbColor.blue, ", ").concat(OPACITY, ")"));
        }

        var onPointClickCallback;

        if (safeHighchartOptions.onPointClick) {
          onPointClickCallback = function onPointClickCallback(event) {
            var options = new _mwChartWordCloudClickOptions.default(event.point);
            return safeHighchartOptions.onPointClick(options);
          };
        }

        var chartData = this.__chartData;
        var safeTooltipFormatter;

        if (safeHighchartOptions.tooltipFormatter) {
          safeTooltipFormatter = function safeTooltipFormatter() {
            var options = new _mwChartWordCloudTooltipOptions.default(
            /* eslint-disable no-invalid-this */
            Object.assign({}, this.point, {
              name: chartData.data[this.point.index].key
            })
            /* eslint-enable no-invalid-this */
            );
            return safeHighchartOptions.tooltipFormatter(options);
          };
        }

        _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            reflow: false,
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            formatter: safeTooltipFormatter,
            useHTML: true
          },
          plotOptions: {
            wordcloud: {
              animation: safeHighchartOptions.animate,
              colors: seriesColor,
              events: {
                click: onPointClickCallback
              },
              maxFontSize: _styles.WORD_CLOUD_MAX_FONT_SIZE,
              minFontSize: _styles.WORD_CLOUD_MIN_FONT_SIZE,
              rotation: {
                from: 0,
                to: 0
              },
              states: {
                hover: {
                  color: safeHighlightColor
                }
              },
              style: {
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.FONT_WEIGHT
              }
            }
          },
          series: highchartsData
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
  }]);
  return MwChartWordCloud;
}();

exports.default = MwChartWordCloud;